import { Component } from '@angular/core';
import { Store } from '@ngxs/store';
import { Configuration } from 'src/app/common/enumerations/enumerations';
import { LoginDialogService } from 'src/app/services/authentication/login-dialog.service';
import { SiteConfigurationService } from 'src/app/components/site-configuration/site-configuration.service';
import { firstValueFrom } from 'rxjs';

@Component({
  selector: 'login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent {

  url?: string;

  constructor(
    private service: LoginDialogService,
    private config: SiteConfigurationService,
    private store: Store
  ) { }

  async ngOnInit() {
    try {
      const configuration = await firstValueFrom(this.config.getValue(Configuration.AccountRequestForm));
      this.url = configuration?.value as string;
    } catch (e) {
      console.error('Failed to load login configuration', e);
    }
  }

  login() {
    this.service.login('/login');
  }
}
